import React, { useState } from "react";
import { message, Popconfirm } from "antd";
import dayjs from "dayjs";
import { capitalizeFirstLetter, formatToINR } from "../../../../helpers/utility";
import { shareBillApi } from "../../../../services/receptionist.services";
import paymentReceivedIcon from "../../../../assets/receptionistIcons/ipBilling/paymentReceived.svg";
import downloadIcon from "../../../../assets/receptionistIcons/ipBilling/download.svg";
import deleteIcon from "../../../../assets/receptionistIcons/ipBilling/delete.svg";
import DeletePaymentModal from "../../../Receptionist/DeletePaymentModal";
import CommonPopOver from "../CommonPopOver";
import styles from "./BillingIp.module.css";
import { getPaymentModeLabel } from "../../../../helpers/paymentModes";

const PaymentHistoryIp = ({
  paymentData,
  bill_id,
  refreshData,
  activePatient,
}) => {
  const [editData, setEditData] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const payments = paymentData?.payments || [];

  const printBill = async (payment_id) => {
    const submitParams = `type=payment&payment_id=${payment_id}&share=download`;
    try {
      const resp = await shareBillApi(bill_id, submitParams);
      const s3Link = resp?.data?.data;
      if (s3Link) {
        window.open(s3Link, "_blank");
      } else {
        message.error("Failed to retrieve download link.");
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Download failed.");
    }
  };

  return (
    <>
      <section className={styles.historyCard}>
        <h3 className={styles.historyTitle}>Payment history</h3>
        {payments.length === 0 ? (
          <p className={styles.emptyHistory}>No payments recorded yet.</p>
        ) : (
          <div className={styles.historyList}>
            {payments.map((record) => {
              const statusLabel =
                record?.status === "delete_requested"
                  ? "Delete requested"
                  : capitalizeFirstLetter(record?.status || "paid");

              return (
                <article key={record.id} className={styles.historyItem}>
                  <img
                    src={paymentReceivedIcon}
                    alt=""
                    className={styles.historyIcon}
                  />
                  <div className={styles.historyMain}>
                    <div className={styles.historyTop}>
                      <span className={styles.historyAmount}>
                        {formatToINR(record.amount)}
                      </span>
                      {record?.status === "paid" && (
                        <span className={styles.paidBadge}>Paid</span>
                      )}
                      {record?.status === "delete_requested" && (
                        <>
                          <span className={styles.deleteRequestBadge}>
                            Delete requested
                          </span>
                          {record?.payment_delete_request_reason && (
                            <CommonPopOver record={record} />
                          )}
                        </>
                      )}
                      {record?.status !== "paid" &&
                        record?.status !== "delete_requested" && (
                        <span className={styles.statusBadge}>{statusLabel}</span>
                      )}
                    </div>
                    <p className={styles.historyMeta}>
                      {dayjs(record.created_at).format("DD MMM YYYY")} ·{" "}
                      {getPaymentModeLabel(record.mode, record.other_mode)}
                    </p>
                  </div>
                  <div className={styles.historyActions}>
                    <button
                      type="button"
                      className={`${styles.iconAction} ${styles.iconActionDownload}`}
                      onClick={() => printBill(record.id)}
                      aria-label="Download receipt"
                    >
                      <img src={downloadIcon} alt="" />
                    </button>
                    {record?.status !== "delete_requested" &&
                      activePatient &&
                      !record?.payment_delete_rejected && (
                        <Popconfirm
                          title="Sure to raise delete request?"
                          onConfirm={() => {
                            setEditData(record.id);
                            setOpenDeleteModal(true);
                          }}
                        >
                          <button
                            type="button"
                            className={styles.iconAction}
                            aria-label="Delete payment"
                          >
                            <img src={deleteIcon} alt="" />
                          </button>
                        </Popconfirm>
                      )}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </section>

      {openDeleteModal && (
        <DeletePaymentModal
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          editData={editData}
          refresh={refreshData}
        />
      )}
    </>
  );
};

export default PaymentHistoryIp;
